// modules
import * as R from 'ramda'
// setup
import { getState } from '../../setup/redux'
// actions
import { SET_IS_OPEN, TOGGLE_IS_OPEN } from './emojiPicker.actions'

const initialState = {
  isOpen: false,
}

// views
export const isOpenView = () => R.prop('isOpen', getState())

// reducers
const reducers = {
  [SET_IS_OPEN]: (_, { value: isOpen }) => ({ isOpen }),
  [TOGGLE_IS_OPEN]: ({ isOpen }) => ({ isOpen: !isOpen }),
}

export default function messageReducer(
  state = initialState,
  { type, payload },
) {
  return reducers[type] ? reducers[type](state, payload) : state
}
